// extracted by mini-css-extract-plugin
module.exports = {"container":"_33LjI","name":"_19kr2"};